function asText(value) {
  return typeof value === "string" ? value.trim() : "";
}

export function formatUserDisplayName(user) {
  if (!user || typeof user !== "object") return "";
  const fullName = asText(user.name);
  if (fullName) return fullName;
  const combined = [asText(user.vorname), asText(user.nachname)].filter(Boolean).join(" ").trim();
  if (combined) return combined;
  const fallback = asText(user.displayName) || asText(user.username) || asText(user.label) || asText(user.email);
  return fallback;
}

export function getInitials(name) {
  const cleaned = asText(name).replace(/\s+/g, " ");
  if (!cleaned) return "?";
  const parts = cleaned.split(" ").filter(Boolean);
  const first = parts[0]?.[0] || "";
  const second = parts.length > 1 ? parts[parts.length - 1]?.[0] || "" : parts[0]?.[1] || "";
  return `${first}${second}`.toUpperCase() || "?";
}

export function resolveAssetUrl(pathValue) {
  const raw = asText(pathValue);
  if (!raw) return null;
  if (/^(https?:)?\/\//i.test(raw)) return raw;
  if (/^data:image\//i.test(raw)) return raw;
  if (/^\/?avatar[_-][^/]+\.(png|jpe?g|gif|webp|svg)$/i.test(raw)) {
    const file = raw.replace(/^\/+/, "");
    return `/uploads/avatars/${file}`;
  }

  if (raw.startsWith("/uploads/")) return raw;
  if (raw.startsWith("uploads/")) return `/${raw}`;
  if (raw.startsWith("public/uploads/")) return `/${raw.replace(/^public\//, "")}`;

  const base = asText(import.meta?.env?.VITE_API_BASE || "");
  if (raw.startsWith("/")) {
    const normalizedPath = raw.startsWith("/uploads/") ? raw : `/uploads${raw}`;
    if (base && /^https?:\/\//i.test(base)) return `${base.replace(/\/+$/, "")}${normalizedPath}`;
    return normalizedPath;
  }
  if (base && /^https?:\/\//i.test(base)) return `${base.replace(/\/+$/, "")}/${raw}`;
  return `/${raw}`;
}

export function normalizeUser(raw) {
  if (!raw) return null;
  const id = Number(raw.id ?? raw.user_id ?? raw.userId ?? raw.assignee_id);
  const name = formatUserDisplayName(raw);
  const email = asText(raw.email || raw.user_email || raw.mail);
  const role = raw.role ?? raw.rolle ?? raw.role_name ?? raw.rolle_name ?? raw.rolle_id ?? raw.role_id ?? null;
  const avatarUrl = resolveAssetUrl(
    raw.avatarUrl ??
      raw.avatar_url ??
      raw.avatar_path ??
      raw.avatar ??
      raw.profile_image_url ??
      raw.profileImage ??
      raw.profilePic ??
      raw.picture ??
      raw.image
  );

  return {
    id: Number.isFinite(id) ? id : null,
    name: name || email || "",
    email: email || null,
    role,
    avatarUrl,
  };
}
